import { Icon, IconOwnProps } from '@mui/material';

type BaseFontIconProps = {
    className: string;
    size?: number;
    color?: IconOwnProps['color'];
};

const BaseFontIcon = ({ className, size = 20, color }: BaseFontIconProps) => {
    return (
        <Icon
            component="i"
            className={className}
            color={color}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: size,
                lineHeight: 1,
                width: '1.25em',
                height: '1em',
                overflow: 'visible',
                verticalAlign: 'middle',
            }}
        />
    );
};

export default BaseFontIcon;
